// import axios from "services/api";;
import axios from "./api";
import { API3_HOST } from '../helpers/urlHelper';

// --- Dashboards
export const getAllDashboards = () => {
  return axios({
    method: 'get',
    url: `${API3_HOST}/dashboard/dashboard`
  });
};

export const getDashboardLayout = id => {
  return axios({
    method: 'get',
    url: `${API3_HOST}/dashboard/dashboard/${id}/layout`
  });
};

export const updateDashboardLayout = (id, layoutJson) => {
  let body = {
    layoutJson: JSON.stringify(layoutJson)
  };
  return axios({
    method: 'put',
    url: `${API3_HOST}/dashboard/dashboard/${id}/layout`,
    data: body
  });
};

export const renameDashboard = (id, name) => {
  let body = {
    name: name
  };
  return axios({
    method: 'post',
    url: `${API3_HOST}/dashboard/dashboard/${id}/rename`,
    data: body
  });
};

// -- Queries
export const executeQuery = id => {
  return axios({
    method: 'get',
    url: `${API3_HOST}/dashboard/query/${id}/execute`
  });
};

// --- Widgets
export const updateWidget = (id, name, queryId, requestMethod, requestUrl, options) => {
  let body = {
    name: name,
    queryId: queryId,
    requestMethod: requestMethod,
    requestUrl: requestUrl,
    options: JSON.stringify(options)
  };

  console.log('REQ OPTIONS', options);
  console.log('REQ OPTIONS STR', body.options);
  return axios({
    method: 'put',
    url: `${API3_HOST}/dashboard/widget/${id}`,
    data: body
  });
};

export const deleteWidget = id => {
  console.log('deleting widget ', id);
  return axios({
    method: 'delete',
    url: `${API3_HOST}/dashboard/widget/${id}`
  });
};
